module.exports = __webpack_public_path__ + "img/pdf.9c9a6c61.svg";